// extracted by mini-css-extract-plugin
module.exports = {"customCard":"Card_customCard__1CCS2","cardBody":"Card_cardBody__3Am4I"};